import { UserRoleCreate } from 'components/user/user-role-create/UserRoleCreate'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { useValidation } from 'hooks/useValidation'
import { USER_ROLE_VALIDATION } from 'services/validation/userRoleValidation'
import { useFetch } from 'services/useFetch'
import { API_USER_ROLE } from 'services/apiUserRole'
import { convertErrorMessage } from 'utils/utils'
import { Alert } from 'avo-ui'
import { useDispatch } from 'react-redux'
import { setReloadMenu } from 'reducers/homeReducer'

const INIT_USER_ROLE = {
    name: null,
    access: [],
}

const FIELD_NAME_DETAIL = {
    name: 'User role name',
}

export const UserRoleCreateContainer = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [searchParams, setSearchParams] = useSearchParams()
    const roleId = searchParams.get('roleId')
    const accessName = searchParams.get('accessName') || 'Home'
    const [userRoleDetail, setUserRoleDetail] = useState(INIT_USER_ROLE)
    const [errorMessage, setErrorMessage] = useState({})
    const { fetching: getRolesDetail, isLoading: isLoadingDetail } = useFetch(API_USER_ROLE.LIST_PERMISSION)
    const { fetching: createRole, isLoading: isCreating } = useFetch(API_USER_ROLE.CREATE)
    const { fetching: updateRole, isLoading: isUpdating } = useFetch(API_USER_ROLE.UPDATE)
    const { validateForm, errorForm } = useValidation({
        form: userRoleDetail,
        schema: USER_ROLE_VALIDATION,
    })

    const setActiveTabHandler = (value) => {
        setSearchParams({ ...(roleId && { roleId }), accessName: value }, { replace: true })
    }

    const getPermissions = (key) => {
        const findPermission = userRoleDetail?.access?.find((item) => item?.name === key)
        return findPermission?.permissions
    }

    const isSelectAll = () => {
        const copyRoleDetail = [...userRoleDetail?.access]
        const accessDetail = copyRoleDetail?.find((item) => item?.name === accessName)
        return accessDetail?.permissions?.every((item) => item?.is_allowed === true)
    }

    const setShowAlert = (message, isError) => {
        return Alert({
            icon: isError ? 'error' : 'success',
            title: isError ? 'Error' : 'Success',
            message,
        })
    }

    const onChangeForm = (e) => {
        let newData
        const { name, value, checked } = e
        const copyRoleDetail = [...userRoleDetail?.access]
        const accessDetail = copyRoleDetail?.find((item) => item?.name === accessName)

        const mapNewPermission = (value) => {
            return accessDetail?.permissions?.map((item) => {
                if (item?.name === name) return { ...item, is_allowed: value }
                return item
            })
        }

        const mapNewAccess = (value) => {
            return copyRoleDetail?.map((item) => {
                if (item?.name === name) return value
                return item
            })
        }

        const mapSelectAll = () => {
            return accessDetail?.permissions?.map((item) => {
                return { ...item, is_allowed: checked }
            })
        }

        if (checked === undefined) {
            newData = { [name]: value }
        } else if (name !== 'Select All') {
            accessDetail['permissions'] = mapNewPermission(checked)
            newData = { access: mapNewAccess(accessDetail) }
        } else {
            accessDetail['permissions'] = mapSelectAll()
            newData = { access: mapNewAccess(accessDetail) }
        }

        setUserRoleDetail({ ...userRoleDetail, ...newData })
    }

    const onSubmit = () => {
        setErrorMessage({})
        validateForm().then(() => {
            const { id, access, ...restDetail } = userRoleDetail
            const payload = {
                ...restDetail,
                permission_ids: access?.reduce((accumulator, currentValue) => {
                    const filterPermissions = currentValue?.permissions?.filter((item) => item?.is_allowed === true)
                    const checkedIds = filterPermissions?.map((item) => item?.id)
                    accumulator = [...accumulator, ...checkedIds]
                    return accumulator
                }, []),
            }

            if (!payload?.permission_ids?.length) return setShowAlert('Please Select Capability !', true)

            if (!id) {
                createRole(payload)
                    .then(() => {
                        dispatch(setReloadMenu())
                        setShowAlert('User Role Created !')
                        navigate('/user/user-role')
                    })
                    .catch((error) => setErrorMessage(convertErrorMessage(error?.data, FIELD_NAME_DETAIL)))
            } else {
                updateRole(payload, id)
                    .then(() => {
                        dispatch(setReloadMenu())
                        setShowAlert('User Role Updated !')
                        navigate('/user/user-role')
                    })
                    .catch((error) => setErrorMessage(convertErrorMessage(error?.data, FIELD_NAME_DETAIL)))
            }
        })
    }

    useEffect(() => {
        if (roleId) {
            getRolesDetail({}, roleId).then((response) => setUserRoleDetail({ ...response?.data }))
        } else {
            getRolesDetail().then((response) => setUserRoleDetail({ ...INIT_USER_ROLE, access: response?.data }))
        }
    }, [roleId])

    const props = {
        userRoleDetail,
        activeTab: accessName,
        setActiveTabHandler,
        getPermissions,
        onChangeForm,
        isSelectAll,
        errorForm: { ...errorForm, ...errorMessage },
        isLoadingDetail,
        isCreating,
        isUpdating,
        onSubmit,
    }

    return <UserRoleCreate {...props} />
}
